import { render, staticRenderFns } from "./CalendarPurchaseOrderDetailDialog.vue?vue&type=template&id=71851db0&"
import script from "./CalendarPurchaseOrderDetailDialog.vue?vue&type=script&lang=js&"
export * from "./CalendarPurchaseOrderDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports